<mat-tab-group>
    @for (tab of tabs(); track $index) {
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="mr-2">{{ tab.icon }}</mat-icon>
                <span>{{ tab.title }}</span>
            </ng-template>
            <ng-template matTabContent>
                <app-offers-tab
                    [title]="tab.title"
                    [icon]="tab.icon"
                    [offersStore]="tab.store"></app-offers-tab>
            </ng-template>
        </mat-tab>
    }
</mat-tab-group>
